import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import moment from 'moment/moment';

import ModalErrorMessage from 'components/ModalErrorMessage/ModalErrorMessage';
import { useModal } from 'hooks/modal/useModal';
import { DATE_FORMAT } from 'utils/formats';

import '../../css/ErrorCell.less';

interface CellDetailsAndActionsProps {
  flux: FluxErrorDetails;
}

export type FluxErrorDetails = {
  nbWarnings?: number;
  error?: string | null;
  id: string;
  dateAppel: string;
};

interface TypeErrorProps {
  flux: FluxErrorDetails;
  openModale: () => void;
}

function ErrorCell({ flux }: CellDetailsAndActionsProps): React.ReactElement {
  const errorModale = useModal();

  return (
    <>
      <TypeError flux={flux} openModale={errorModale.open} />
      <ModalErrorMessage
        visible={errorModale.visible}
        close={errorModale.close}
        errorMessage={flux.error}
        title={`Message d'erreur sur l'appel du ${moment(flux.dateAppel).format(
          DATE_FORMAT,
        )}`}
      />
    </>
  );
}

export default ErrorCell;

function TypeError({ flux, openModale }: TypeErrorProps): React.ReactElement {
  const { pathname } = useLocation();

  if (flux.error) {
    return (
      <Link onClick={openModale} to={'#'} className={'linkOnErrorOrWarning'}>
        Flux KO
      </Link>
    );
  } else if (flux.nbWarnings && flux.nbWarnings > 0) {
    return (
      <Link
        to={`${pathname}/${flux.id}?dateFlux=${flux.dateAppel}`}
        className={'linkOnErrorOrWarning'}
      >
        Retours non interprétés ({flux.nbWarnings}).
      </Link>
    );
  } else {
    return <div>/</div>;
  }
}
